module.exports = __webpack_public_path__ + "static/media/1_en.ce5dade6.png";